module.exports = __webpack_public_path__ + "img/logo-02.07438209.png";